import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AuthProvider } from './providers/AuthProvider';
import { Toaster } from 'react-hot-toast';
import MainLayout from './components/layout/MainLayout';
import NotificationInitializer from './components/NotificationInitializer';
import LoginForm from './components/LoginForm';
import Dashboard from './pages/dashboard';
import Profile from './pages/profile-page';
import UsersPage from './pages/users-page';
import JobCardsPage from './pages/jobcards-page';
import EditJobCardPage from './pages/edit-jobcard-page';
import JobCardSignaturesPage from './pages/jobcard-signatures-page';
import StoresPage from './pages/stores-page';
import SettingsPage from './pages/settings-page';
import InventoryPage from './pages/inventory-page';
import InventoryManagePage from './pages/inventory-manage-page';
import ProtectedRoute from './components/ProtectedRoute';
import ViewJobCardPage from './pages/view-jobcard-page';
import EquipmentPage from './pages/equipment-page';
import EquipmentMaintenance from './pages/EquipmentMaintenance';
import ThemeInitializer from './components/ThemeInitializer';
import PositionsDepartmentsPage from './pages/positions-departments-page';
import SopCompletionPage from './pages/SopCompletionPage';
import CacheManagementPage from './pages/CacheManagementPage';
import NotificationSettingsPage from './pages/NotificationSettingsPage';
import { RootState } from './store';

export default function AppContent() {
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);
  const isAdmin = isAuthenticated && user?.utype === 'ADMIN';
  
  const hasEquipmentMaintenanceAccess = isAuthenticated && Boolean(
    isAdmin || 
    (user?.position?.department?.name && 
     user.position.department.name.toLowerCase().includes('maintenance'))
  );

  return (
    <BrowserRouter>
      <ThemeInitializer />
      <NotificationInitializer />
      <AuthProvider>
        <Toaster position="top-right" toastOptions={{
          duration: 4000,
          style: {
            background: '#333',
            color: '#fff',
          },
          success: {
            style: {
              background: '#059669',
            },
          },
          error: {
            style: {
              background: '#DC2626',
            },
            duration: 5000,
          },
        }} />
        <Routes>
          <Route path="/login" element={<LoginForm />} />

          <Route path="/" element={<MainLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="users" element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <UsersPage />
              </ProtectedRoute>
            } />
            <Route path="positions-departments" element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <PositionsDepartmentsPage />
              </ProtectedRoute>
            } />
            <Route path="jobcards" element={
              <ProtectedRoute>
                <JobCardsPage />
              </ProtectedRoute>
            } />
            <Route path="jobcards/edit/:id" element={
              <ProtectedRoute>
                <EditJobCardPage />
              </ProtectedRoute>
            } />
            <Route path="jobcards/view/:id" element={
              <ProtectedRoute>
                <ViewJobCardPage />
              </ProtectedRoute>
            } />
            <Route path="jobcards/:id/signatures" element={
              <ProtectedRoute>
                <JobCardSignaturesPage />
              </ProtectedRoute>
            } />
            <Route path="sop-completion/:completionId" element={
              <ProtectedRoute>
                <SopCompletionPage />
              </ProtectedRoute>
            } />
            <Route path="stores" element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <StoresPage />
              </ProtectedRoute>
            } />
            <Route path="settings" element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <SettingsPage />
              </ProtectedRoute>
            } />
            <Route path="inventory" element={
              <ProtectedRoute>
                <InventoryPage />
              </ProtectedRoute>
            } />
            <Route path="inventory/manage" element={
              <ProtectedRoute>
                <InventoryManagePage />
              </ProtectedRoute>
            } />
            <Route path="equipment" element={
              <ProtectedRoute>
                <EquipmentPage />
              </ProtectedRoute>
            } />
            <Route path="equipment-maintenance" element={
              hasEquipmentMaintenanceAccess ? (
                <ProtectedRoute>
                  <EquipmentMaintenance />
                </ProtectedRoute>
              ) : (
                <Navigate to="/dashboard" replace />
              )
            } />
            <Route path="pots" element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                {/* Add the Pots page component here */}
                <div>Pots Page Placeholder</div>
              </ProtectedRoute>
            } />
                                        <Route path="cache-management" element={
          <ProtectedRoute>
            <CacheManagementPage />
          </ProtectedRoute>
            } />
                    <Route path="notifications/settings" element={
          <ProtectedRoute>
            <NotificationSettingsPage />
          </ProtectedRoute>
            } />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
} 